import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "mt-2 mb-2" };
const _hoisted_2 = ["href", "alt", "target"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.element.content)
            ? (_openBlock(), _createBlock(_component_g_dynamic_html, {
                key: 0,
                template: '<div>' + _ctx.element.content + '</div>'
            }, null, 8, ["template"]))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.element.address,
                alt: _ctx.element.tooltip,
                target: _ctx.element.target
            }, _toDisplayString(_ctx.element.label), 9, _hoisted_2))
    ]));
}
